export default "__VITE_ASSET__b5de3eab__"